module.exports = __webpack_public_path__ + "static/media/icon_153.4b42081f.svg";